import { Button, Col, Form, Row } from "antd";
import React, { useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { FormBox, InputBox } from "../../../../components/AntdAddons";
import { validations } from "../../../../config/validations/validations";
import { disabledSaveBtn } from "../../../../config/Global";

interface PropsInterface {
  getList: any;
  setPaginationData: any;
  companies: any;
}

const FilterForm: React.FC<PropsInterface> = (props) => {
  const [form] = Form.useForm();
  const { getList, setPaginationData, companies } = props;
  const [disabledClear, setDisabledClear] = useState(true);
  const [disabledSearch, setDisabledSearch] = useState(true);
  const handleSubmit = (data: any) => {
    data.name = data?.name ? data?.name : "";
    data.number = data?.number ? data?.number : "";
    setPaginationData({
      page_number: 1,
      page_size: 10,
    });
    getList(data);
    setDisabledClear(false);
  };
  const clear = () => {
    form.resetFields();
    form.setFieldsValue({ name: null });
    const payload = {
      page_number: 1,
      page_size: 10,
    };
    setDisabledClear(true);
    setDisabledSearch(true);
    setPaginationData({
      page_number: 1,
      page_size: 10,
    });
    getList(payload);
  };
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        const isDisabled = disabledSaveBtn(form);
        setDisabledSearch(isDisabled);
      })
      .catch((e: any) => {
        console.warn(e);
      });
  };
  return (
    <>
      <FormBox
        className="filterForm"
        form={form}
        onFinish={handleSubmit}
        onChange={handleChange}
        validateTrigger={["onChange"]}
        autoComplete="off"
      >
        <Row gutter={30} align={"middle"}>
          <Col xs={24} md={12} lg={6}>
            <InputBox.Select
              label="Select Company"
              name={"company_name"}
              required
              placeholder="company"
              onChange={handleChange}
              allowClear
              options={{
                list: companies ? companies : [],
                valueKey: "value",
                textKey: "label",
              }}
              rules={[validations.required.select()]}
            />
          </Col>
          <Col xs={24} md={12} lg={6}>
            <InputBox.Text
              name="company_number"
              label="Number"
              rules={[validations.pattern.numeric]}
            />
          </Col>
          <Col xs={24} md={12} lg={6}>
            <InputBox.Text name="name" label="Name" />
          </Col>
        </Row>
        <Row gutter={30} align={"middle"}>
          <Col xs={12} md={12} lg={4}>
            <Button type="primary" htmlType="submit" disabled={disabledSearch}>
              <SearchOutlined /> Search
            </Button>
          </Col>
          <Col xs={12} md={12} lg={4}>
            <Button
              type="default"
              htmlType="reset"
              disabled={disabledClear}
              onClick={() => {
                clear();
              }}
            >
              Clear
            </Button>
          </Col>
        </Row>
      </FormBox>
    </>
  );
};

export default FilterForm;
